import useScrollReveal from "../hooks/useScrollReveal";

const stats = [
  { value: "5%", label: "REVENUE SHARE", color: "text-white" },
  { value: "12 MONTHS", label: "EARNING WINDOW", color: "text-[#FFF528]" },
  { value: "∞", label: "REFERRAL LIMIT", color: "text-white" },
];

const ReferralHero = () => {
  const [imgRef, imgVisible] = useScrollReveal(0.1);
  const [headRef, headVisible] = useScrollReveal(0.1);
  const [statsRef, statsVisible] = useScrollReveal(0.1);

  return (
    <section className="flex flex-col items-center text-center px-6 pt-20 pb-16 sm:pt-8 sm:pb-12">
      {/* Illustration */}
      <div
        ref={imgRef}
        className={`transition-all duration-700 ease-out ${
          imgVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-6"
        }`}
      >
        <img
          src="/images/referral.png"
          alt="Earn by referring"
          onError={(e) => {
            e.currentTarget.src =
              "https://placehold.co/320x180/111315/FFF528?text=Referral+Image";
          }}
          className="w-96 sm:w-64 md:w-96 object-contain mx-auto"
        />
      </div>

      {/* Headline */}
      <div
        ref={headRef}
        className={`mt-6 transition-all duration-700 delay-150 ease-out ${
          headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <h1 className="font-[Norwester] font-semibold text-white uppercase tracking-wider leading-tight text-4xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-4xl 2xl:text-5xl mb-4">
          Earn by Growing the
        </h1>
        <h1 className="font-[Norwester] font-semibold text-[#FFF528] uppercase tracking-wider leading-tight text-4xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-4xl 2xl:text-5xl">
          Vupop Community
        </h1>
        <p className="mt-4 text-[rgba(255,255,255,0.60)] text-sm sm:text-xs max-w-xl mx-auto font-sans leading-relaxed">
          Invite friends, creators, and fans to join Vupop and earn a share of
          the revenue they generate for up to 12 months after joining.
        </p>
      </div>

      {/* Stats row */}
      <div
        ref={statsRef}
        className={`mt-20 sm:mt-10 w-full max-w-2xl grid grid-cols-3 sm:grid-cols-3 gap-4 transition-all duration-700 delay-300 ease-out ${
          statsVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-6"
        }`}
      >
        {stats.map(({ value, label, color }, i) => (
          <div
            key={i}
            className={`flex flex-col items-center gap-1 ${
              i === 1
                ? "border-l border-r border-[rgba(255,255,255,0.1)] px-4"
                : ""
            }`}
          >
            <span
              className={`font-[Norwester]  ${color} text-3xl sm:text-lg md:text-2xl`}
            >
              {value}
            </span>
            <span className="text-[rgba(255,255,255,0.45)] text-[10px] sm:text-[9px] mt-1 tracking-widest uppercase font-sans">
              {label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ReferralHero;